'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname, useRouter } from 'next/navigation';
import { useEffect } from 'react';
import { CheckoutProgressStepper } from '~/components/CheckoutProgressStepper';
import { TRIP_SECTION_LABELS, TRIP_SECTIONS, useTripJourneyActions } from '~/stores/tpv2/journeyStore';
import styles from './TripProgressStepper.module.css';
const STEPS = TRIP_SECTIONS.map(s => TRIP_SECTION_LABELS[s]);
const getStepIndexFromPathname = (pathname: string): number => {
  const segments = pathname.split('/').filter(Boolean);
  for (const segment of segments) {
    const index = TRIP_SECTIONS.indexOf(segment as (typeof TRIP_SECTIONS)[number]);
    if (index >= 0) return index;
  }
  return 0;
};
const getPathnameForStepIndex = (index: number, basePath: string, tripId: string): string => {
  const base = basePath.replace(/\/$/, '') || '/';
  if (index <= 0) return `${base}/${tripId}`;
  return `${base}/${TRIP_SECTIONS[index]}/${tripId}`;
};
export interface TripProgressStepperProps {
  basePath?: string;
  tripId: string;
}
export const TripProgressStepper = t0 => {
  const $ = _c(18);
  const {
    basePath: t1,
    tripId
  } = t0;
  const basePath = t1 === undefined ? "/poc-v2" : t1;
  const router = useRouter();
  const pathname = usePathname();
  const currentStepIndex = getStepIndexFromPathname(pathname ?? "");
  const {
    setActiveSection,
    setCurrentStepIndex
  } = useTripJourneyActions();
  let t2;
  let t3;
  if ($[0] !== currentStepIndex || $[1] !== setActiveSection || $[2] !== setCurrentStepIndex) {
    t2 = () => {
      setCurrentStepIndex(currentStepIndex);
      setActiveSection(TRIP_SECTIONS[currentStepIndex]);
    };
    t3 = [currentStepIndex, setActiveSection, setCurrentStepIndex];
    $[0] = currentStepIndex;
    $[1] = setActiveSection;
    $[2] = setCurrentStepIndex;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== basePath || $[6] !== currentStepIndex || $[7] !== router || $[8] !== tripId) {
    t4 = () => {
      if (currentStepIndex > 0) {
        router.push(getPathnameForStepIndex(currentStepIndex - 1, basePath, tripId));
      } else {
        router.back();
      }
    };
    $[5] = basePath;
    $[6] = currentStepIndex;
    $[7] = router;
    $[8] = tripId;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const onBack = t4;
  const t5 = currentStepIndex > 0 ? onBack : undefined;
  let t6;
  if ($[10] !== basePath || $[11] !== tripId) {
    t6 = index => getPathnameForStepIndex(index, basePath, tripId);
    $[10] = basePath;
    $[11] = tripId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <CheckoutProgressStepper.Frame><CheckoutProgressStepper.TopRow><CheckoutProgressStepper.BackButton /><CheckoutProgressStepper.Steps /></CheckoutProgressStepper.TopRow><CheckoutProgressStepper.ProgressBar /></CheckoutProgressStepper.Frame>;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== currentStepIndex || $[15] !== t5 || $[16] !== t6) {
    t8 = <div className={styles.wrapper}><CheckoutProgressStepper.Provider steps={STEPS} currentStepIndex={currentStepIndex} onBack={t5} hrefForStep={t6}>{t7}</CheckoutProgressStepper.Provider></div>;
    $[14] = currentStepIndex;
    $[15] = t5;
    $[16] = t6;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};